export enum GshopListingStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Disapproved = "DISAPPROVED",
  Pending = "PENDING",
}
